<template>
    <div>
        <div v-if="!passwordChanged" class="template">
            <p><span>Użytkownik: </span><b-input v-model="userData.name" disabled></b-input></p>
            <p><span>Login: </span><b-input v-model="userData.user" disabled></b-input></p>
            <p><span>Stare hasło: </span><b-input v-model="oldPassword" type="password"></b-input></p>
            <p><span>Nowe hasło: </span><b-input v-model="newPassword" type="password"></b-input></p>
            <p v-if="badOldPassword">Niepoprawne stare hasło</p>
            <div class="buttons">
                <b-button class="button" v-on:click="applyChanges">Zatwierdź</b-button>
                <b-button class="button" v-on:click="cancelChanges">Anuluj</b-button>
            </div>
        </div>
        <div v-if="passwordChanged">
            <p>Hasło zmienione poprawnie</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import{path} from '../../../config';
import crypto from 'crypto';
export default {
    name: 'PasswordChange',
    props: {
        userData: Object,
    },
    methods: {
        applyChanges: function(){
            let hash = crypto.createHash('sha1');
            let data = hash.update(this.oldPassword, 'utf-8');
            let gen_hash = data.digest('hex');
            console.log(this.userData, gen_hash)
            if(gen_hash === this.userData.password){
                let hash = crypto.createHash('sha1');
                let data = hash.update(this.newPassword, 'utf-8');
                let gen_hash = data.digest('hex');
                const payload = {
                    user: this.userData.user,
                    password: gen_hash,
                    name: this.userData.name,
                    isAdmin: this.userData.isAdmin,
                } 
                console.log(payload)
                axios
                    .put(`${path}login/db/${this.userData.id}`, payload)
                    .then(r => (
                        console.log(r.status),
                        this.badOldPassword = false,
                        this.passwordChanged = true
                        ))
                    .catch(e => console.log(e));
            } else {
                this.badOldPassword = true;
            }
        },
        cancelChanges: function(){
            this.$emit('cancelProfile')
        }
    },
    data: function(){
        return{
            oldPassword: '',
            newPassword: '',
            badOldPassword: false,
            passwordChanged: false,
        }
    }
}
</script>

<style lang="scss" scoped>
    .template {
        border-top: solid;
        border-bottom: solid;
        border-color: blue;
        border-width: 2px;
        border-radius: 10px;
        margin-bottom: 5px;
        text-align: left;
        padding-left: 10px;
        p{
            margin: 0;
        }
        .buttons {
            display: flex;
            justify-content: space-evenly;
            margin: 5px 0;
        }
        span {
            font-weight: bold;
        }
        .showGroups {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 5px;
            p{
                margin: 0 5px;
                padding: 0 5px;
                border: solid;
                border-width: 1px;
            }
            button {
                margin: 5px;
                border: none;
                font-family: 'Source Code Pro', monospace;
                color: white;
            }
        }
    }
    .confirm{
        background-color: red;
        margin: 10px 0;
        border-radius: 10px;
        color: white;
        padding: 0 5px;
        .button {
            margin: 5px;
        }
    }
    .correct {
        background-color: green;
    }
    .negative {
        background-color: red;
    }
</style>